import { Outlet } from 'react-router-dom';
import { Header } from "../Header/Header";
import Footer from "../Footer/Footer";

const ChinaLayout = () => {
 
  return (
    <div>
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer isIndia={false} />
    </div>
  );
};

export default ChinaLayout;

